import styles from './styles.module.scss'
import IconPeople from '/public/icons/icon-people.svg'
import IconBedroom from '/public/icons/icon-bedrooms.svg'
import IconBathroom from '/public/icons/icon-bathroom.svg'
import { withModifiers } from '../../helpers/withModifiers'

const HouseDetails = ({ persons, bedrooms, bathrooms, variant = [] }) => (
  <div className={withModifiers('details', variant, styles)}>
    {persons && (
      <div className={styles.details__item}>
        <IconPeople className={styles.details__icon} />

        <div className={styles.details__details}>{persons}</div>
      </div>
    )}

    {bedrooms && (
      <div className={styles.details__item}>
        <IconBedroom className={styles.details__icon} />

        <div className={styles.details__details}>{bedrooms}</div>
      </div>
    )}

    {bathrooms && (
      <div className={styles.details__item}>
        <IconBathroom width={24} height={15} className={styles.details__icon} />

        <div className={styles.details__details}>{bathrooms}</div>
      </div>
    )}
  </div>
)

export default HouseDetails
